import { render, staticRenderFns } from "./emailTemplate.vue?vue&type=template&id=1d71bf6b&scoped=true&"
import script from "./emailTemplate.vue?vue&type=script&lang=js&"
export * from "./emailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./emailTemplate.vue?vue&type=style&index=0&id=1d71bf6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d71bf6b",
  null
  
)

export default component.exports